import styled from "styled-components";

// Default Option Wrapper extracted from Oxygen codebase, only flex-direction added
// https://github.com/8x8/oxygen/blob/master/packages/select/examples/Select.guidelines.stories.tsx#L101
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  border-bottom: 1px solid #e0e0e0;
  color: ${({ theme }) => theme.optionTextColor};
  cursor: pointer;
  font-size: 0.75rem;
  padding: 12px 16px;
  text-align: left;
  &:hover {
    background-color: ${({ theme }) => theme.optionHoveredBackgroundColor};
  }
`;

const WrappingText = styled.div`
  word-wrap: break-word;
`;

export const AgentOption = ({ innerProps, data }) => {
  return (
    <OptionWrapper {...innerProps}>
      <WrappingText>
        First Name: <strong>{data.agent.profile?.first_name}</strong>
      </WrappingText>
      <WrappingText>
        Last Name: <strong>{data.agent.profile?.last_name}</strong>
      </WrappingText>
      <WrappingText>
        Email: <strong>{data.agent.profile?.email}</strong>
      </WrappingText>
      <WrappingText>
        ID: <strong>{data.agent.id}</strong>
      </WrappingText>
    </OptionWrapper>
  );
};

export const QueueOption = ({ innerProps, data }) => {
  return (
    <OptionWrapper {...innerProps}>
      <WrappingText>
        Name: <strong>{data.queue.name}</strong>
      </WrappingText>
      <WrappingText>
        Media Type: <strong>{data.queue.media_type}</strong>
      </WrappingText>
      <WrappingText>
        ID: <strong>{data.queue.id}</strong>
      </WrappingText>
    </OptionWrapper>
  );
};
